import React, { useEffect, useRef, useState } from "react";
import styles from "./ScmHeader.module.scss";
import cart_icon from "../../../assets/svg/cart_icon.svg";
import profile_partner_icon from "../../../assets/svg/userProfile.svg";
import logout_outlined from "../../../assets/svg/logout_outlined.svg";
import profile_outlined from "../../../assets/svg/profile_outlined.svg";
import marketplace_logo from "../../../assets/svg/marketplace.svg";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  doLogout,
  getDropdownOption,
  getFromLocalStorage,
  getTokenData,
  setInLocalStorage,
} from "../../../common/utility";
import { Paths } from "../../../Routes/path";
import arrowUpper from "../../../assets/svg/arrowUpper.svg";
import { getScmCircles } from "../../../api/ProductCatalogAPI";
import Dropdown from "../../atoms/Dropdown/Dropdown";
import {
  setScmCart,
  setScmCircle,
  setScmCircleOptions,
} from "../../../redux/actions/actions";
import store from "../../../redux/store";
import { testIds } from "../../../common/testData";
import { getCartDetails, saveScmCart } from "../../../api/ScmCartAPI";

function useOutsideAlerter(ref, cbk) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        cbk(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [ref]);
}

const ScmHeader = ({ scmHeaderData }) => {
  const [open, setOpen] = useState(false);
  const [cirles, setCircles] = useState([]);
  const [selectedCircle, setSelectedCircle] = useState("");
  const { sub, given_name, family_name, preferred_username, realm_access } =
    getTokenData();
  const { dispatch } = store;
  const { cart } = scmHeaderData;
  const { circle } = getFromLocalStorage("scm", "circle") || {};
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setOpen);
  const navigate = useNavigate();

  const fetchCircles = async () => {
    const response = await getScmCircles();
    if (response) {
      setCircles(getDropdownOption(response));
      dispatch(setScmCircleOptions(getDropdownOption(response)));
    }
  };

  const fetchCart = async () => {
    const response = await getCartDetails({ userId: sub });
    if (response?.products) {
      dispatch(setScmCart(response.products));
    }
  };

  const saveCart = async () => {
    const payload = {
      userId: sub,
      products: cart,
    };
    await saveScmCart(payload);
  };

  useEffect(() => {
    fetchCircles();
    fetchCart();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const timeOutId = setTimeout(() => saveCart(), 1000);
    return () => clearTimeout(timeOutId);
    // eslint-disable-next-line
  }, [JSON.stringify(cart)]);

  useEffect(() => {
    circle && setSelectedCircle(circle);
    // eslint-disable-next-line
  }, [circle]);

  return (
    <div
      className={styles.headerComponent}
      data-testid={testIds["scm-header-component"]}
    >
      <div className={styles.headerElement}>
        <img
          src={marketplace_logo}
          alt="logo"
          className={styles.pointer}
          onClick={() => navigate(Paths.scmDashboard.path)}
        />
      </div>
      <div className={styles.headerElement}>
        <div className={styles.circleDropdown}>
          <Dropdown
            disabled={
              !window.location.pathname.includes(
                Paths.scmProductCatalog.path
              ) && !window.location.pathname.includes(Paths.scmDashboard.path)
            }
            value={selectedCircle}
            onChange={({ value }) => {
              if (value !== circle) {
                setSelectedCircle(value);
                setInLocalStorage("scm", "circle", { circle: value });
                dispatch(setScmCircle(value));
                dispatch(setScmCart([]));
              }
            }}
            label="Select Circle"
            options={cirles}
          />
        </div>
        <div className={styles.cartBox}>
          <img
            src={cart_icon}
            alt="logo"
            width={20}
            height={20}
            className={styles.pointer}
            onClick={() => navigate(Paths.scmCart.path)}
          />
          {cart?.length > 0 && <span>{cart.length}</span>}
        </div>
        <div
          data-testid={testIds["scm-header-profile-section"]}
          className={styles.profileSection}
          onClick={() => setOpen(!open)}
        >
          <img
            src={profile_partner_icon}
            alt="logo"
            width={30}
            height={30}
            className={styles.pointer}
          />
          <div className={styles.idSection}>
            <span className={styles.name}>
              {given_name + " " + (family_name ? family_name : "")}
            </span>
            <span className={styles.id}>
              {preferred_username?.toUpperCase()}
              <img
                src={arrowUpper}
                alt="uparrow"
                className={`${styles.up} ${open && styles.open}`}
                width={20}
                height={20}
              />
            </span>
          </div>
          {open && (
            <div ref={wrapperRef}>
              <div className={styles.profileOverlay} />
              <div className={styles.profileDropdown}>
                <div
                  className={`${styles.logout} ${styles.option}`}
                  onClick={() => {
                    navigate(Paths.scmOrders.path);
                  }}
                >
                  <img src={profile_outlined} alt="my orders" />
                  My Orders
                </div>
                {realm_access?.roles.includes("ADMIN") && <>
                  <div
                    className={`${styles.logout} ${styles.option}`}
                    onClick={() => {
                      navigate(Paths.scmBulkUpload.path);
                    }}
                  >
                    <img src={profile_outlined} alt="catalog bulk upload" />
                    Catalog Bulk Upload
                  </div>
                  <div
                    className={`${styles.logout} ${styles.option}`}
                    onClick={() => {
                      navigate(Paths.scmManageCatalog.path);
                    }}
                  >
                    <img src={profile_outlined} alt="manage catalog" />
                    Manage Catalog
                  </div></>
                }
                <div
                  className={`${styles.logout} ${styles.option}`}
                  onClick={() => {
                    doLogout();
                  }}
                >
                  <img src={logout_outlined} alt="logout" />
                  Log Out
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  scmHeaderData: state.scmHeaderData,
});

export default connect(mapStateToProps)(ScmHeader);
